import axios from "axios";
import { config } from "../config";
import { validateEmail, websiteValidation } from "./validation";

export const validateWebsiteData = ({ name, email, website }) => ({
  name: name.length <= 2,
  email: !validateEmail(email),
  website: !websiteValidation(website),
});

export const scrapeWebsite = async (
  userWebsiteData,
  HTTP_REFERER,
  HTTP_USER_AGENT,
  $_COOKIE
) => {
  try {
    const response = await axios.post(
      `${config.BASE_API_URL}/api/v1/clients/scrape-data`,
      {
        name: userWebsiteData.name,
        email: userWebsiteData.email,
        website: userWebsiteData.website,
        phone: userWebsiteData.phone,
        HTTP_REFERER,
        HTTP_USER_AGENT,
        $_COOKIE,
      }
    );
    return response.data;
  } catch (error) {
    if (error.response) {
      throw new Error(error.response.data);
    } else {
      throw new Error("Something went wrong");
    }
  }
};
